module.exports = __webpack_public_path__ + "static/banner-tablet-74ca7d348b5488b6443763ccb80ee12d.png";